import React, {
  useState,
  useMemo,
  useCallback,
  useContext,
  createContext
} from 'react'

import PropTypes from 'prop-types'

const Activities = createContext(null)

const ActivitiesProvider = ({ children }) => {
  const [selectedPlotIndex, setSelectedPlotIndex] = useState(null)
  const [selectedPlotId, setSelectedPlotId] = useState(0)
  const [selectedHarvest, setSelectedHarvest] = useState({
    label: 'General',
    value: '0'
  })

  const changePlot = useCallback((id, index) => {
    if (id === selectedPlotId) {
      setSelectedPlotId(0)
      setSelectedPlotIndex(null)
      return
    }

    setSelectedPlotId(id)
    setSelectedPlotIndex(index)
  }, [selectedPlotId])

  const changeHarvest = useCallback(harvest => {
    setSelectedHarvest(harvest)
    changePlot(0, null)
  }, [changePlot])

  const value = useMemo(() => ({
    changeHarvest,
    changePlot,
    currentHarvest: selectedHarvest,
    currentPlotId: selectedPlotId,
    currentPlotIndex: selectedPlotIndex
  }), [changeHarvest, changePlot, selectedHarvest, selectedPlotId, selectedPlotIndex])

  return (
    <Activities.Provider value={ value }>
      { children }
    </Activities.Provider>
  )
}

export const useActivities = () => {
  const context = useContext(Activities)

  if (!context) {
    throw new Error('useActivities must be used within an ActivitiesProvider')
  }

  return context
}

ActivitiesProvider.propTypes = {
  children: PropTypes.element.isRequired
}

export default ActivitiesProvider
